import styles from "./PendingStat.module.css";

/**
 * A grey bar where a stat will appear once the topic stats run that computes
 * it finishes.
 */
export function PendingStat() {
  return <span className={styles.pending} role="img" aria-label="Pending" />;
}
